/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useHistory } from "react-router-dom";
import AdminSubscribes from "../../components/newsletter/AdminSubscribes";
import Boards from "../../components/newsletter/Boards";

//Import PageHeader
import PageHeader from "../../components/PageHeader";

// Redux Store
import queryString from "query-string";
import { shallowEqual, useSelector } from "react-redux";
import MailForms from "../../components/newsletter/MailForms";

const Newsletter = () => {
  const history = useHistory();
  const [activeTab, setActiveTab] = useState();
  const { user } = useSelector(
    (store) => ({
      user: store.Profile.user,
    }),
    shallowEqual
  );

  const _setActiveTab = (value) => {
    history.push(`/admin/newsletter/${value}?tab=${value}`);
  };

  const tabList = [
    {
      label: (
        <>
          뉴스레터 구독자 관리 <small className="color-red-100 font-size-10">new</small>
        </>
      ),
      action: _setActiveTab,
      value: "subscribe",
    },
    {
      label: (
        <>
          뉴스레터 게시물 관리 <small className="color-red-100 font-size-10">new</small>
        </>
      ),
      action: _setActiveTab,
      value: "board",
    },
    {
      label: (
        <>
          뉴스레터 메일폼 관리 <small className="color-red-100 font-size-10">new</small>
        </>
      ),
      action: _setActiveTab,
      value: "mail-form",
    },
  ];

  useEffect(() => {
    const query = queryString.parse(history.location.search);
    setActiveTab(query.tab || tabList[0].value);
  }, [history.location]);

  return (
    <>
      <PageHeader
        title={`안녕하세요, ${user && user.name}님.`}
        activeTab={activeTab}
        tabList={tabList}
      />
      {activeTab === "subscribe" && <AdminSubscribes />}
      {activeTab === "board" && <Boards />}
      {activeTab === "mail-form" && <MailForms />}
    </>
  );
};

export default Newsletter;
